import '.em{max-width:560px;}.ssr-plugin'
import '.c1{padding:48px;}.ssr-plugin'
import '.en{height:calc(100vh - 124px);}.ssr-plugin'
import '.b1{box-sizing:border-box;}.ssr-plugin'
import '.e{display:flex;}.ssr-plugin'
import '.f{flex-direction:column;}.ssr-plugin'
import '.cy{justify-content:center;}.ssr-plugin'
import '.bn{margin-bottom:24px;}.ssr-plugin'
import '.bq{margin-bottom:72px;}.ssr-plugin'
import { styled } from 'inlines'
import { Button } from '../../components/Button.js'
import { Icon } from '../../assets/icons/index.js'
import { colors } from '../../utils/colors.js'
import { TABLET, MOBILE, HEIGHT } from '../../utils/breakpoints.js'

export const StepTwo = ({ step, setStep, dictionary }) => {
  return (
    <styled.div className="em c1 en b1 e f cy"
      id="onboarding-step-two-content"
      style={{
        [TABLET]: {
          padding: '24px',
        },
        [MOBILE]: {
          height: 'calc(100dvh - 124px)',
          boxSizing: 'border-box',
          justifyContent: 'flex-end',
        },
      }}
    >
      <styled.div
        style={{
          [MOBILE]: {
            marginTop: '0px',
            marginBottom: '0px',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          },
        }}
      >
        <h2 className="bn">
          {dictionary.tutorialMaxVotes}
        </h2>
        <styled.h3 className="bq"
          style={{
            color: colors.primary,
            [MOBILE]: { marginBottom: 24 },
            [HEIGHT]: {
              marginBottom: '12px',
            },
          }}
        >
          {dictionary.tutorialVotePrice}
        </styled.h3>
      </styled.div>
      <Button
        ariaLabel={dictionary?.continueButton}
        id="onboarding-step-two-action-open-step-three"
        trailIcon={<Icon type="forwardIcon" color={colors.secondary} />}
        fullWidth
        onClick={() => setStep(step + 1)}
      >
        {dictionary?.continueButton}
      </Button>
    </styled.div>
  )
}
